<div class="login-body">
    <p-toast key="top" position="top-center">
    </p-toast>
    <div class="login-panel">
        <div class="flex-col">
            <div class="login-header">
                <img class="login-logo" [src]="app.getLogoLoginPngUrl()" />
                <h1>Passwort vergessen</h1>
                <h2>{{app.appName}}</h2>
            </div>
            <sm-form [form]="userName == null ? form1 : form2">
            </sm-form>
            @if (running) {
            <div>
                <div>Rücksetzung läuft ...</div>
                <p-progressSpinner></p-progressSpinner>
            </div>
            }
        </div>
    </div>
</div>